import axios from "axios";
import { default as LogHandler, LogType } from "@/helpers/utilities/Handlers/LogHandler";

import msalConnection from "@/helpers/api/msalConnection";
import * as msal from "@azure/msal-browser";

var axiosBySpMap = {};
var getRequestsMap = {};

export default {
  async get(path) {
    if (!getRequestsMap[path]) {
      const axios = await this.getAxiosByPath(path);

      const request = axios.get(path).finally(() => {
        getRequestsMap[path] = null;
      });

      getRequestsMap[path] = request;
    }
    return getRequestsMap[path];
  },

  getAxiosByPath(path) {
    const regex = /^(https?:\/\/?[^:/]*).*$/g; // https://regex101.com/r/afHZ2J/1
    const split = regex.exec(path);

    // Token timeout 50 secs
    if (!axiosBySpMap[split[1]] || axiosBySpMap[split[1]].initTime < new Date().getTime() - 3000000) {
      axiosBySpMap[split[1]] = {
        connection: this.init(split[1]),
        initTime: new Date().getTime()
      };
    }
    return axiosBySpMap[split[1]].connection;
  },

  async init(spPath) {
    try {
      const request = {
        account: msalConnection.msalAccount,
        scopes: [spPath + "/.default"]
      };

      const tokenObject = await msalConnection.msalInstance.acquireTokenSilent(request).catch(async error => {
        if (error instanceof msal.InteractionRequiredAuthError) {
          msalConnection.msalInstance.acquireTokenRedirect(request);
        } else {
          this.signOut();
        }
      });

      const sharepointApi = axios.create();
      sharepointApi.defaults.headers.common["Authorization"] = `Bearer ${tokenObject.accessToken}`;
      return sharepointApi;
    } catch (error) {
      LogHandler.log(LogType.ERROR, "sharepointApi", error);
    }
  },

  signOut() {
    msalConnection.signOut();
  }
};
